export default "__VITE_ASSET__a335f8cc__"